import React, { useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import './address.scss';
import Button from '../../common/Button/Button';
import Loader from '../../../components/mweb/Skeletons/Loader/Loader';
import AddressCard from './AddressCard';
import {
  DEFAULT_COORDS,
  GEOLOCATION_TIMEOUT,
  initializeMap,
} from 'hb-redux-store/util/locationService';
import { getCustomerCompleteAddressList } from 'hb-redux-store/feature/address/address.action';
import history from 'hb-redux-store/history';
import {
  deleteAddress,
  setDefaultAddress,
} from 'hb-redux-store/feature/address/address.action';
import {
  validateSelectedLocationForNudge,
  removeShoppingCart,
  validateUserLocation,
} from 'hb-redux-store/feature/checkout/checkout.action';
import ResetCartOnAdcChangeModal from '../Modal/ResetCartOnAdcChangeModal';
import {
  checkoutPrefix,
  getCheckoutRoute,
} from '../../../feature/checkout/checkout.routes';
import { ACCOUNTS_PREFIX } from '../../../feature/account/accounts.routes';
import {
  getSubscriptionRoute,
  subscriptionPrefix,
} from '../Subscription/subscription.routes';

const geolocation = navigator.geolocation;

const Addresses = props => {
  const {
    source,
    getCustomerCompleteAddressList,
    addresses,
    loadingAddress,
    validateSelectedLocationForNudge,
    removeShoppingCart,
  } = props;
  const [selectedAddressId, setSelectedAddressId] = React.useState(null);
  const [showNudge, setNudge] = React.useState(false);
  const [showModal, setModal] = React.useState(false);
  const [validateNudgeObject, setValidateNudgeObject] = React.useState({});
  const [addAddressDisabled, setAddAddressDisabled] = React.useState(false);
  useEffect(() => {
    getCustomerCompleteAddressList();
  }, []);
  const onSelectedAddressChange = (selectedAddressId, address) => {
    setSelectedAddressId(selectedAddressId);
    setNudge(true);
    setValidateNudgeObject({});
    validateSelectedLocationForNudge(address, resp => {
      setNudge(resp?.resetCart);
      const { adcCode, cityId, newAddress, resetCart } = resp;
      setValidateNudgeObject({
        ...address,
        adcCode,
        cityId,
        newAddress,
        resetCart,
      });
    });
  };

  const setDefaultAddress = addressId => props.setDefaultAddress({ addressId });
  const deleteAddress = addressId => props.deleteAddress({ addressId });
  const isCheckout = source === 'checkout';
  const isAccounts = source === 'accounts';
  const isSubscription = source === subscriptionPrefix;
  let prefix = ACCOUNTS_PREFIX;
  if (isCheckout) prefix = checkoutPrefix;
  if (isSubscription) prefix = subscriptionPrefix;
  const newAddressLink = `/${prefix}/new-address?new=true`;
  let onDeliverRoute = getCheckoutRoute('shipment');
  if (isSubscription) onDeliverRoute = getSubscriptionRoute('payment');
  return (
    <div className="addresses">
      {!loadingAddress && (
        <Fragment>
          <div className="addresses--new-address-cta">
            <Button
              className="button button-ghost large full-width"
              disabled={addAddressDisabled}
              onClick={() => {
                setAddAddressDisabled(true);
                geolocation.getCurrentPosition(
                  position => {
                    console.log('position: ', position);
                    initializeMap(position);
                    // setTimeout(() => {
                    history.push(newAddressLink);
                    // }, 50);
                  },
                  err => {
                    console.log('error: ', err);
                    const defaultGeoLocation = {
                      coords: DEFAULT_COORDS,
                    };
                    initializeMap(defaultGeoLocation);
                    history.push(newAddressLink);
                  },
                  { timeout: GEOLOCATION_TIMEOUT }
                );
              }}
            >
              Add new address
            </Button>
          </div>
          <div className="section-divider"></div>
        </Fragment>
      )}
      {loadingAddress && <Loader />}
      {!loadingAddress &&
        addresses?.map((address, i) => {
          return (
            <React.Fragment key={i}>
              <AddressCard
                address={address}
                source={source}
                onSelectedAddressChange={onSelectedAddressChange}
                selectedAddressId={selectedAddressId}
                goToShipment={address => {
                  if (showNudge) {
                    setModal(true);
                  } else {
                    props.validateUserLocation(address, () =>
                      history.push(onDeliverRoute)
                    );
                  }
                }}
                onSetDefaultAddress={setDefaultAddress}
                onDelete={deleteAddress}
              />
              <div className="section-divider" />
            </React.Fragment>
          );
        })}
      <ResetCartOnAdcChangeModal
        visible={showModal}
        onCancel={() => setModal(false)}
        onOk={() => {
          removeShoppingCart(validateNudgeObject, () => {
            setValidateNudgeObject({});
            setNudge(false);
            history.goBack();
          });
        }}
      />
    </div>
  );
};

const mapStateToProps = ({ addressReducer }) => ({
  addresses: addressReducer.addresses,
  loadingAddress: addressReducer.loadingAddress,
});
const mapDispatchToProps = {
  getCustomerCompleteAddressList,
  setDefaultAddress,
  deleteAddress,
  validateSelectedLocationForNudge,
  removeShoppingCart,
  validateUserLocation,
};

export default connect(mapStateToProps, mapDispatchToProps)(Addresses);
